function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["className", "disabled"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../themes/alert.js";
import { borderRadiusMedium } from "../../../../themes/borders.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { BaseLink } from "../base-link/base-link.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseLink, _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-link__standard': true,
      'bf-link__standard--disabled': disabled
    }, "".concat(className), className)),
    disabled: disabled,
    ref: ref
  }));
});
var Link = styled(BaseStandardLink)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n  color: ", ";\n  display: inline-block;\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:focus-visible {\n    color: ", ";\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  &[aria-disabled='true'] {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), borderRadiusMedium, function (_ref) {
  var theme = _ref.theme;
  return theme.link.textColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.link.textColorHover;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.link.textColorActive;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.link.textColorFocus;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.link.outlineColorFocus;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.link.textColorDisabled;
});
var StandardLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Link, _extends({}, props, {
    ref: ref
  })));
});
export { BaseStandardLink, StandardLink };